import React, { useEffect, useState } from "react";

import { useHistory } from "react-router-dom";
import { useToasts } from "react-toast-notifications";

import { useFormik } from "formik";
import * as Yup from "yup";

import { IRequirement } from "../../../@types/types";
import { CreateAndDetailLayout } from "../../../components/CreateAndDetailLayout";
import { GroupInput } from "../../../components/Form/GroupInput";
import { Input } from "../../../components/Form/Input";
import { LayoutForm } from "../../../components/Form/LayoutForm";
import { Select } from "../../../components/Form/Select";
import Loading from "../../../components/Loading";
import { PanelAndDetailAndCreateHeader } from "../../../components/panel/PanelAndDetailAndCreateHeader";
import api from "../../../service/api";
import { ButtunSubmit, ContainerForm, ScreenLoading } from "../styles";

interface Props {
  location: {
    state: {};
  };

  match: {
    params: {
      id: number;
    };
  };
}

const Detail: React.FC<Props> = ({ match }) => {
  const { addToast } = useToasts();
  const history = useHistory();

  const [contentPage, setContentPage] = useState<IRequirement>();

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (match.params.id) {
      (async () => {
        const dataDB = await api.get<any>(`/requirement/${match.params.id}`);

        setContentPage(dataDB.data);
        setLoading(false);
      })();
    }
  }, [match.params.id]);

  useEffect(() => {
    if (contentPage) {
      if (contentPage.id) formik.setFieldValue("id", contentPage.id);
      if (contentPage.description)
        formik.setFieldValue("description", contentPage.description);
      if (contentPage.value) formik.setFieldValue("value", contentPage.value);
      if (contentPage.is_active)
        formik.setFieldValue("is_active", contentPage.is_active);
    }
    // eslint-disable-next-line
  }, [contentPage]);

  async function handleSubmit(updates: any) {
    try {
      await api.put(`/requirement/${updates.id}`, {
        value: updates.value,
        description: updates.description,
        is_active: Boolean(Number(updates.is_active)),
      });
      addToast("Setor alterado com sucesso", {
        appearance: "success",
        autoDismiss: true,
      });
      history.push("/requisitos");
    } catch (err) {
      const error = err as any;
      if (!error.response) {
        return addToast(
          "Desculpe, ocorreu um erro interno, Tente novamente mais tarde",
          {
            appearance: "error",
            autoDismiss: true,
          }
        );
      }

      addToast(
        "Desculpe, ocorreu um erro interno, Tente novamente mais tarde",
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
    }
  }

  const formik = useFormik({
    initialValues: {
      id: undefined,
      value: undefined,
      description: undefined,
      is_active: undefined,
    },
    validationSchema: Yup.object({
      value: Yup.string().required("Nome é obrigatório"),
      description: Yup.string().required("Abreviação é obrigatório"),
    }),
    onSubmit: (data) => handleSubmit(data),
  });

  return (
    <CreateAndDetailLayout>
      {!loading ? (
        <>
          <PanelAndDetailAndCreateHeader title={"Criar Requisito"} goBack />

          <ContainerForm>
            <LayoutForm onSubmit={formik.handleSubmit}>
              <Input
                label="ID"
                {...formik.getFieldProps("id")}
                type="number"
                style={{ borderStyle: "dashed" }}
                disabled
              />

              <GroupInput>
                <Input
                  label="Descrição"
                  {...formik.getFieldProps("description")}
                  error={
                    formik.touched.description && formik.errors.description
                      ? formik.errors.description
                      : undefined
                  }
                />

                <Select
                  data={[
                    { name: "Sim", value: "1" },
                    { name: "Não", value: "0" },
                  ]}
                  label="Ativo"
                  {...formik.getFieldProps("is_active")}
                  error={
                    formik.touched.is_active && formik.errors.is_active
                      ? formik.errors.is_active
                      : undefined
                  }
                />
              </GroupInput>

              <Input
                label="Valor"
                {...formik.getFieldProps("value")}
                error={
                  formik.touched.value && formik.errors.value
                    ? formik.errors.value
                    : undefined
                }
              />

              <ButtunSubmit type="submit"> Alterar dados </ButtunSubmit>
            </LayoutForm>
          </ContainerForm>
        </>
      ) : (
        <ScreenLoading>
          <Loading
            colorLoading="#333"
            size={40}
            borderColor={"#888"}
            borderSize={5}
          />
        </ScreenLoading>
      )}
    </CreateAndDetailLayout>
  );
};

export default Detail;
